import OrdersTableRow from './ordersTableRow';
import { Loader } from 'elements/loader';

import { OrderT } from 'types';

import NoDataIcon from 'assets/images/ghost.svg';

interface Props {
  currentTab: string;
  orders: OrderT[];
  handlerCancelOrder: Function;
  isOrdersLoading: boolean;
  isCancelOrderLoading: boolean;
  isCancelSignOrderLoading: boolean;
  selectedOrderId?: string;
}

const OrdersTableContent = ({
  currentTab,
  orders,
  handlerCancelOrder,
  isOrdersLoading,
  isCancelOrderLoading,
  isCancelSignOrderLoading,
  selectedOrderId,
}: Props) => {
  if (isOrdersLoading) {
    return (
      <div className="orders-table-loader">
        <Loader color={'black'} />
      </div>
    );
  }

  if (orders.length > 0) {
    return (
      <>
        {orders.map(order => (
          <OrdersTableRow
            currentTab={currentTab}
            key={order.id}
            order={order}
            handlerCancelOrder={handlerCancelOrder}
            isCancelOrderLoading={isCancelOrderLoading}
            isCancelSignOrderLoading={isCancelSignOrderLoading}
            selectedOrderId={selectedOrderId}
          />
        ))}
      </>
    );
  }

  return (
    <div className="orders-table-empty">
      <div className="orders-table-empty-img">
        <img src={NoDataIcon} alt="orders" />
      </div>
      <span className="orders-table-empty-text">{_t('No Orders', 'VIEW_ORDERS.NO_ORDERS')}</span>
    </div>
  );
};

export default OrdersTableContent;
